require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./central-precinct-entertainment-zone.json") })
        }
      }, "path---central-precinct-entertainment-zone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---central-precinct-entertainment-zone!./.cache/json/central-precinct-entertainment-zone.json
// module id = 848
// module chunks = 231608221292675